import { gql } from '@apollo/client'

// Fragment definitions
export const USER_FRAGMENT = gql`
  fragment UserFragment on User {
    id
    email
    firstName
    lastName
    city
    country
    source
    favorites
    createdAt
    updatedAt
  }
`

export const COMPANY_FRAGMENT = gql`
  fragment CompanyFragment on Company {
    id
    name
    createdAt
    updatedAt
  }
`

export const PROJECT_FRAGMENT = gql`
  fragment ProjectFragment on Project {
    id
    name
    country
    primaryMetal
    secondaryMetals
    stage
    firstProductionDate
    firstProductionPrecision
    latitude
    longitude
    isFavorite
    createdAt
    updatedAt
    owners {
      id
      name
      ownership
    }
    resources {
      category
      metal
      tonnage
      grade
      content
    }
    reserves {
      category
      metal
      tonnage
      grade
      content
    }
    production {
      metal
      production
      min
      max
      period
    }
    aisc {
      metal
      cost
      min
      max
      period
    }
    cashCost {
      metal
      cost
      min
      max
      period
    }
  }
`

// User queries
export const GET_USER = gql`
  query GetUser($id: ID!) {
    getUser(id: $id) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`

export const GET_USER_BY_EMAIL = gql`
  query GetUserByEmail($email: String!) {
    getUserByEmail(email: $email) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`

export const GET_USER_FAVORITES = gql`
  query GetUserFavorites($userId: ID!) {
    getUserFavorites(userId: $userId) {
      ...ProjectFragment
    }
  }
  ${PROJECT_FRAGMENT}
`

// Project queries
export const LIST_PROJECTS = gql`
  query ListProjects($filter: ProjectFilter, $limit: Int, $nextToken: String) {
    listProjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        ...ProjectFragment
      }
      nextToken
      total
    }
  }
  ${PROJECT_FRAGMENT}
`

export const GET_PROJECT = gql`
  query GetProject($id: ID!) {
    getProject(id: $id) {
      ...ProjectFragment
    }
  }
  ${PROJECT_FRAGMENT}
`

export const SEARCH_PROJECTS = gql`
  query SearchProjects($searchTerm: String!, $limit: Int) {
    searchProjects(searchTerm: $searchTerm, limit: $limit) {
      ...ProjectFragment
    }
  }
  ${PROJECT_FRAGMENT}
`

// Company queries
export const LIST_COMPANIES = gql`
  query ListCompanies($limit: Int, $nextToken: String) {
    listCompanies(limit: $limit, nextToken: $nextToken) {
      items {
        ...CompanyFragment
        production {
          quarter
          year
          metal
          quantity
          isEstimated
        }
        costs {
          quarter
          year
          aisc
        }
      }
      nextToken
      total
    }
  }
  ${COMPANY_FRAGMENT}
`

export const GET_COMPANY = gql`
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      ...CompanyFragment
      production {
        quarter
        year
        metal
        quantity
        isEstimated
      }
      costs {
        quarter
        year
        aisc
      }
    }
  }
  ${COMPANY_FRAGMENT}
`

export const GET_COMPANY_PROJECTS = gql`
  query GetCompanyProjects($companyId: ID!) {
    getCompanyProjects(companyId: $companyId) {
      ...ProjectFragment
    }
  }
  ${PROJECT_FRAGMENT}
`

// Watchlist fragment
export const WATCHLIST_FRAGMENT = gql`
  fragment WatchlistFragment on Watchlist {
    id
    name
    userId
    projectIds
    createdAt
    updatedAt
  }
`

// Watchlist queries
export const GET_USER_WATCHLISTS = gql`
  ${WATCHLIST_FRAGMENT}
  query GetUserWatchlists($userId: ID!) {
    getUserWatchlists(userId: $userId) {
      ...WatchlistFragment
    }
  }
`

export const GET_WATCHLIST = gql`
  ${WATCHLIST_FRAGMENT}
  query GetWatchlist($watchlistId: ID!) {
    getWatchlist(watchlistId: $watchlistId) {
      ...WatchlistFragment
    }
  }
`
